<!--
 * @Author: Tang Yuxuan
 * @Date: 2020-10-12 11:00:51
 * @LastEditTime: 2020-10-28 18:35:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \writing_pc\src\components\writing\errorCorrection.vue
-->
<!-- 论文纠错 -->
<template>
<div class="errorCorrection" v-loading="loading" element-loading-text="">
    <div class="title_row">
        <span class="left_span"><span class="shu"></span> 论文纠错</span>
        <button class="h_btn" v-if="!$root.stateType.isLogin" @click="showVip()">智能纠错</button>
        <button class="h_btn h_btnok" v-if="$root.stateType.isLogin" @click="correct()">智能纠错</button>
    </div>

    <div :class="mgs_golink? 'mgs_golink':'noshow'">
        <div style="display: flex; align-items: center;">
            此为会员才能使用的功能，
        </div> <button @click="go_vip()">去开通</button>
        <button @click="mgs_golink=false" style="margin-left:20px"><img src="/static/images/tishi_chacha_default.png" alt="" srcset=""></button>
    </div>
    <div class="non404" v-if="listData.length==0">
        <div>
            <img class="userimg" src="/static/images/non404_xiangsiyuan.png" alt="" srcset="" />
            <p>你还未进行过纠错 <br>进行纠错后查看纠错结果</p>
            <button class="btn_err" @click="correct()">立即纠错</button>
        </div>
    </div>

    <div class="list" v-if="listData.length>0">
        <div class="list_row" v-for="(item,index) in listData" :key="index">
            <div class="title_h3"><span>{{item.title}}</span>
                <div class="icon_box" v-if="item.status==4"><span class="dowbg" @click="open(item.htmlUrl)"></span> <span class="dow" @click="open(item.downloadUrl)"></span> </div>
            </div>
            <div class="time"><img src="/static/images/chachong_shijianbiao.png" alt="" srcset=""> {{item.createTime}}</div>
            <div class="error_type">
                <div class="type"><img src="/static/images/chachong_jianchezhong.png" alt="" srcset="">{{status[item.status-1]||'纠错失败'}}</div>
                <div>疑似错别字 <span class="red" v-if="item.status==4">{{item.wrongCount != null ? item.wrongCount : 0 +'字'}}</span><span class="red" v-else>-</span></div>
            </div>
        </div>
    </div>
    <div class="flooter" v-if="listData.length>0">
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :total="total"></el-pagination>
    </div>

</div>
</template>

<script>
export default {
    props: ['id'],
    data: function () {
        return {
            listData: [],
            status: ['等待纠错', '提交中', '纠错中', '纠错完成'],
            pages: {
                articleId: this.$route.query.id,
                current: 1,
                size: 10
            },
            loading: false,
            total: 1,
            mgs_golink: false
        };
    },
    components: {},
    created: function () {
        this.correctList()
    },
    mounted: function () {

    },
    methods: {
        /**
         * 纠错
         */
        correct: function () {

            if (document.getElementById("editor").innerText.length == 1) {
                this.$message({
                    message: res.msg,
                    type: 'warning'
                });
                return false
            }
            this.loading = true
            this.api
                .correct(
                    this.$route.query.id
                )
                .then(res => {
                    this.loading = false
                    if (res.code == 0) {
                        let mgs = `<div style="display: flex; align-items: center;"><img src="/static/images/gou.png" style="margin-right:5px;width:14px;height:14px" alt="" srcset="" /> 提交成功</div>`;
                        this.$message({
                            dangerouslyUseHTMLString: true,
                            iconClass: "none",
                            showClose: true,
                            message: mgs,
                            customClass: "mymessage",
                            duration: 1000
                        });
                        this.correctList()
                    } else {
                        if (res.code == 2004) {
                            this.$prompt('<p style="text-align: center;margin-bottom: 10px;color: #66686E;font-size: 12px;">' + res.msg + '</p>', '温馨提示', {
                                showInput: false,
                                dangerouslyUseHTMLString: true,
                                cancelButtonClass: "myno",
                                confirmButtonClass: "next",
                                confirmButtonText: "我知道了",
                            }).then(res => {}).catch(() => {});;
                        }
                        if (res.code == 2002) {
                            this.mgs_golink = true
                            setTimeout(() => {
                                this.mgs_golink = false
                            }, 3000);
                        }

                    }

                });
        },

        /**
         * 下载或预览
         */
        open: function (url) {
            window.open(url, '_blank').location;
        },
        showVip() {
            this.mgs_golink = true
            setTimeout(() => {
                this.mgs_golink = false
            }, 3000);
        },
        /**
         * 纠错列表
         */
        correctList: function (id) {
            this.loading = true
            this.api.correctList(this.pages).then(res => {
                this.loading = false
                this.listData = res.data.records
                this.total = res.data.total
            })
        },
        handleCurrentChange: function (val) {
            console.log(`当前页: ${val}`);
            this.pages.current = val
            this.correctList()
        },
        go_vip() {
           this.oauthapi.vipRedirectUrl().then(res => {
                if(res.code == 0) {
                    window.open(res.data.attributeValue, "_blank");
                }
            })
        },
    }
};
</script>

<style lang="scss" scoped>
.errorCorrection {
    width: calc(100% - 80px);
    padding: 0 40px;

    .mgs_golink {
        position: fixed;
        z-index: 99999;
        left: 40%;
        top: 54px;
        background: #ffffff;
        transition: top 0.3s;
        padding: 10px;
        border-radius: 4px;
        display: flex;
        color: #66686E;
        border: 1px solid #CCCCCC;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);

        button {
            color: #C79758;
            background: none;
            border: none;
        }
    }

    .noshow {
        position: fixed;
        z-index: 0;
        left: 40%;
        top: -100px;
        background: #ffffff;
        padding: 10px;
        border-radius: 4px;
        display: flex;
        color: #66686E;
        border: 1px solid #CCCCCC;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    }

    .title_row {
        color: $btnc;
        display: flex;
        justify-content: space-between;
        padding: 20px 0;

        .left_span {
            display: flex;
            align-items: center;
            font-size: 18px;
            font-weight: bold;

            .shu {
                border-left: 4px solid $btnc;
                height: 18px;
                display: inline-block;
                margin-right: 12px;
            }
        }

        .h_btn {
            color: #ffffff;
            border: none;
            background: linear-gradient(0deg, #8A8A8A 0%, #A8A8A8 100%);
            padding: 0 10px;
            border-radius: 20px;
            font-size: 14px;
            height: 28px;
        }

        .h_btnok {
            background: linear-gradient(0deg, #5676BD 0%, #7395DE 100%);
        }

    }

    .non404 {
        text-align: center;
        margin-top: 168px;

        img {
            width: 111px;
            height: 111px;
        }

        p {
            margin-top: 38px;
            font-size: 14px;
            color: #989EA2;
            line-height: 22px;
        }

        .btn_err {
            color: $btnc;
            background: none;
            border: none;
            margin-top: 24px;
        }
    }

    .list {
        height: calc(100vh - 180px);
        overflow: auto;
    }

    .list_row+.list_row {
        margin-top: 16px;
    }

    .list_row {

        border: 1px solid #EEEEEE;
        border-radius: 4px;
        padding: 16px 20px;

        .title_h3 {
            display: flex;
            justify-content: space-between;
            align-items: center;

            span {
                font-size: 16px;
                font-weight: bold;
                color: #34343A;
            }

            .icon_box {
                display: flex;
                align-items: center;

                img {
                    height: 12px;
                    margin-left: 10px;
                }
            }
        }

        .time {
            display: flex;
            align-items: center;
            color: #989EA2;
            margin-top: 12px;

            img {
                width: 14px;
                height: 14px;
                margin-right: 8px;
            }
        }

        .dowbg {
            display: inline-block;
            width: 16px;
            height: 12px;
            background: url('/static/images/chachong_eye_default.png');
        }

        .dowbg:hover {
            background: url('/static/images/chachong_eye_hover.png');
        }

        .dow {
            display: inline-block;
            width: 16px;
            height: 12px;
            background: url('/static/images/chachong_download_default.png') no-repeat;
            background-size: 14px 11px;
            margin-left: 8px;
        }

        .dow:hover {
            background: url('/static/images/chachong_download_hover.png') no-repeat;
            background-size: 14px 11px;
        }

        .error_type {
            display: flex;
            justify-content: space-between;
            margin-top: 20px;

            .type {
                display: flex;
                align-items: center;

                img {
                    margin-right: 8px;
                }
            }

            .red {
                color: #FF5A5A;
                font-size: 16px;
            }
        }
    }

    .flooter {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/writing/errorCorrection.vue